import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ActivateRole, PagedProfile, Profile } from '../models/Profile';
import { ProfileClaims } from '../models/ProfileClaims';

@Injectable({
  providedIn: 'root'
})
export class AspNetAppRoleService {
  readonly APIURL = environment.APIURL;
  public profile!: Profile[];

  public profileClaims: ProfileClaims = {
    seeKaizenList: true,
    submitKaizen: true,
    editDeleteKaizen: true,
    updateKaizenAfterApproval: true,
    planApprovalforBudget: true,
    editKaizenafterPlanApproved: true,
    addUserAccess: true,
    removeUserAccess: true
  };
  
  constructor(private httpClient: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  setActiveRole(updateRole:ActivateRole){
    console.log(updateRole);
    return this.httpClient.put(this.APIURL+`/AspNetUserRole/`,updateRole,this.httpOptions);
  }

  getAspNetUserRole(email: string): Observable<PagedProfile> {
    return this.httpClient.get<PagedProfile>(this.APIURL + '/AspNetUserRole/' + email, this.httpOptions);
  }


  setProfileClaim(role: string) {

    if (role == 'Viewer') {
      this.profileClaims.seeKaizenList = true;
      this.profileClaims.submitKaizen = false;
      this.profileClaims.editDeleteKaizen = false;
      this.profileClaims.updateKaizenAfterApproval = false;
      this.profileClaims.planApprovalforBudget = false;
      this.profileClaims.editKaizenafterPlanApproved = false;
      this.profileClaims.addUserAccess = false;
      this.profileClaims.removeUserAccess = false;
    }
    else if (role == 'Submitter') {
      this.profileClaims.seeKaizenList = true;
      this.profileClaims.submitKaizen = true;
      this.profileClaims.editDeleteKaizen = true;
      this.profileClaims.updateKaizenAfterApproval = true;
      this.profileClaims.planApprovalforBudget = false;
      this.profileClaims.editKaizenafterPlanApproved = true;
      this.profileClaims.addUserAccess = false;
      this.profileClaims.removeUserAccess = false;
    }
    else if (role == 'CMDApprover') {

      this.profileClaims.seeKaizenList = true;
      this.profileClaims.submitKaizen = false;
      this.profileClaims.editDeleteKaizen = false;
      this.profileClaims.updateKaizenAfterApproval = false;
      this.profileClaims.planApprovalforBudget = true;
      this.profileClaims.editKaizenafterPlanApproved = false;
      this.profileClaims.addUserAccess = false;
      this.profileClaims.removeUserAccess = false;
    }
    else if (role == 'SystemAdmin') {
      this.profileClaims.seeKaizenList = true;
      this.profileClaims.submitKaizen = true;
      this.profileClaims.editDeleteKaizen = true;
      this.profileClaims.updateKaizenAfterApproval = true;
      this.profileClaims.planApprovalforBudget = true;
      this.profileClaims.editKaizenafterPlanApproved = true;
      this.profileClaims.addUserAccess = true;
      this.profileClaims.removeUserAccess = true;
    }
    else if (role == 'ISAdmin') {
      this.profileClaims.seeKaizenList = true;
      this.profileClaims.submitKaizen = true;
      this.profileClaims.editDeleteKaizen = true;
      this.profileClaims.updateKaizenAfterApproval = true;
      this.profileClaims.planApprovalforBudget = true;
      this.profileClaims.editKaizenafterPlanApproved = true;
      this.profileClaims.addUserAccess = true;
      this.profileClaims.removeUserAccess = true;
    }
    else if (role == 'CMDApproverPlus') {
      this.profileClaims.seeKaizenList = true;
      this.profileClaims.submitKaizen = true;
      this.profileClaims.editDeleteKaizen = true;
      this.profileClaims.updateKaizenAfterApproval = true;
      this.profileClaims.planApprovalforBudget = true;
      this.profileClaims.editKaizenafterPlanApproved = true;
      this.profileClaims.addUserAccess = true;
      this.profileClaims.removeUserAccess = true;
    }
    return this.profileClaims;
  }

}
